import { onBeforeUnmount, watch, unref, isRef, type MaybeRef } from 'vue'

export function useEventListener(
  target: MaybeRef<EventTarget | null | undefined>,
  event: string,
  handler: EventListener,
  options?: AddEventListenerOptions
): void {
  let cleanup: (() => void) | undefined

  const attach = (el: EventTarget | null | undefined) => {
    cleanup?.()
    cleanup = undefined

    if (!el) return

    el.addEventListener(event, handler, options)
    cleanup = () => el.removeEventListener(event, handler, options)
  }

  if (isRef(target)) {
    watch(target, (newTarget) => attach(newTarget), { immediate: true })
  } else {
    attach(unref(target))
  }

  onBeforeUnmount(() => {
    cleanup?.()
  })
}
